module.exports = __webpack_public_path__ + "static/Flow Data Table FAQ-1eb9834ea4d7e112a19f8300475643c3.pdf";